import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import MaterialSize from "material-table";


const LoginHistory = (props) => {

    useEffect(() => {
        props.setHeading("View Login History");
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialSize
                    title="View Login History"
                    columns={[
                        { title: 'Date', field: 'date', editable: 'never', },
                        { title: 'Attempt', field: 'attempt', editable: 'never', },
                        { title: 'User Name', field: 'userName', editable: 'never', },
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/users/login-history?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + (query.page);
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: "POST",
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky",
                            top: 0,
                            color: "#00BBBB",
                            fontWeight: "550",
                            onRowAdd: "none",
                            whiteSpace: 'nowrap',
                        },
                        rowStyle: {
                            whiteSpace: 'nowrap',
                        },
                        cellStyle: {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                    }}
                />
            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(LoginHistory);